import libCopy from './copy.reducer'
import libCopyBulk from './copyBulk.reducer'
import libCopyCategories from './copyCategories.reducer'
import libCopyFilters from './copyFilters.reducer'

const store = { libCopy, libCopyFilters, libCopyBulk, libCopyCategories }

export default store
